export function isLoginMfaChallenge(r) {
    return "mfaRequired" in r && r.mfaRequired === true;
}
//# sourceMappingURL=auth.js.map